// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__YZ57k","col":"CardReaderDesc_col__2ohAu","label":"CardReaderDesc_label__1x0Mo"};